// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchFiltersSidebar from 'components/SearchFiltersSidebar';
import {
  areFiltersDefault,
  sideFacetsForType
} from 'utils/search/searchFacets';
import { isLocationEmpty } from 'utils/search/sidefilters';
import type { Dispatch } from '../redux/main';
import {
  updateSearchLocation,
  clearSearchLocation
} from '../redux/main/actions/currentUser';
import {
  setSearchFilter,
  selectSearchFilterOption,
  deselectSearchFilterOption,
  selectAllSearchFilterOptions,
  setSearchSort,
  setSearchRadius,
  clearAllFilters
} from '../redux/main/actions/mainSearch';
import type { GradSortType } from '../redux/main/reducers/mainSearch';

const mapStateToProps = ({
  currentUser: { searchLocation },
  searchRadius,
  mainSearch: { query, sort, filters, searchFacets, facetsThatArentLoaded }
}) => ({
  searchLocation,
  searchRadius: searchRadius.value,
  sort: sort[filters.type],
  filters,
  searchFacets,
  facetsThatArentLoaded,
  query
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators(
    {
      setSearchFilter,
      selectSearchFilterOption,
      deselectSearchFilterOption,
      selectAllSearchFilterOptions,
      setSearchRadius,
      setSearchSort,
      clearAllFilters
    },
    dispatch
  ),
  setSearchLocation: (searchLocation: ?SearchLocation) => {
    if (searchLocation) {
      dispatch(updateSearchLocation(searchLocation, true));
    } else {
      dispatch(clearSearchLocation(true));
    }
  },
  setSearchRadius: (searchRadius: string) => {
    dispatch(setSearchRadius(searchRadius, true));
  }
});

type Props = {
  query: string,
  searchLocation: ?SearchLocation,
  searchRadius: string,
  sort: GradSortType,
  filters: SearchFilters,
  searchFacets: Object,
  setSearchFilter: Function,
  selectSearchFilterOption: Function,
  deselectSearchFilterOption: Function,
  selectAllSearchFilterOptions: Function,
  setSearchLocation: Function,
  setSearchRadius: Function,
  setSearchSort: Function,
  clearAllFilters: Function,
  facetsThatArentLoaded: Array<string>
};

const GradSchoolsSearchFiltersSidebarContainer = ({
  filters,
  searchFacets,
  facetsThatArentLoaded,
  ...otherProps
}: Props) => {
  const facets = filters.type
    ? sideFacetsForType(searchFacets, filters.type)
    : [];
  const facetsToRender = facets.filter(facet => {
    if (!facet.lazy) return true;
    return !facetsThatArentLoaded.includes(facet.name);
  });
  const searchLocationActive = !isLocationEmpty(otherProps.searchLocation);
  const defaultFiltersSet =
    areFiltersDefault(
      sideFacetsForType(searchFacets, 'GRAD_PROGRAM'),
      facetsThatArentLoaded,
      filters
    ) && !searchLocationActive;
  const sortOptionsNamed = [
    {
      name: getText('Program Name'),
      baseParam: 'program-name',
      defaultOrder: 'asc'
    },
    {
      name: getText('Average Financial Aid'),
      baseParam: 'financial-aid',
      defaultOrder: 'desc'
    },
    {
      name: getText('Number of Students'),
      baseParam: 'nb-of-students',
      defaultOrder: 'asc'
    },
    {
      name: getText('Acceptance Rate'),
      baseParam: 'acceptance-rate',
      defaultOrder: 'asc'
    }
  ];
  return (
    <SearchFiltersSidebar
      filters={filters}
      facetsToRender={facetsToRender}
      searchableFacets={[]}
      sortOptionsNamed={sortOptionsNamed}
      defaultFiltersSet={defaultFiltersSet}
      searchLocationActive={searchLocationActive}
      {...otherProps}
    />
  );
};
export default connect<Props, {||}, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(GradSchoolsSearchFiltersSidebarContainer);
